import * as angular from 'angular';

import { ComponentDefinition } from '../../../../models';

export interface UploadPanelConfiguration {
    title: string;
    buttonTooltip: string;
    invalid?: string;
    controlId: string;
    fileExtension: string;
    upload: (fileList: FileList) => angular.IPromise<void>;
}


class UploadPanelController implements angular.IComponentController {
    configuration: UploadPanelConfiguration;
    fileList: FileList;
    static $inject = [];

    uploadFile() {
        if (this.configuration && this.configuration.upload) {
            const promise = this.configuration.upload(this.fileList);
            if (promise) {
                promise
                    .finally(() => this.fileList = undefined);
            } else {
                this.fileList = undefined;
            }
        }
    }
}

export const wtUploadPanel: ComponentDefinition = {
    componentId: 'wtUploadPanel',
    controller: UploadPanelController,
    template: require('./uploadPanel.component.html'),
    controllerAs: 'vm',
    bindings: {
        configuration: '<',
        isLoading: '<?'
    }
};
